import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import InputLabel from "@material-ui/core/InputLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import ImageIcon from "@material-ui/icons/Image";
import AddBoxIcon from "@material-ui/icons/AddBox";
import { Grid, Button, Typography } from "@material-ui/core";
import Fade from "@material-ui/core/Fade";

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 5,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
  },
  header: {
    backgroundColor: theme.palette.primary.dark,
    color: "white",
    fontWeight: "bold",
    padding: theme.spacing(2, 4, 2),
  },
  form: {
    marginTop: 12,
    padding: theme.spacing(2, 4, 3),
  },
  margin: {
    marginBottom: 12,
  },
  img: {
    border: "2px solid lightgrey",
    borderRadius: 5,
    width: 150,
    height: 180,
    objectFit: "contain",
  },
}));

const ProductsForm = ({
  product,
  folders,
  onSubmit,
  loading,
  submitText,
  headerText,
  errors,
}) => {
  const classes = useStyles();
  const [name, setName] = useState("");
  const [unitPrice, setUnitPrice] = useState("");
  const [folder, setFolder] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(undefined);
  const [image, setImage] = useState(undefined);
  const [editedFile, setEditedFile] = useState(false);

  const handleFileSelection = (selectedFile) => {
    if(selectedFile){
      setFile(selectedFile);
      setImage(URL.createObjectURL(selectedFile));
      setEditedFile(true);
    }
  };

  useEffect(() => {
    if (product) {
      setName(product.name);
      setUnitPrice(product.unitPrice);
      setFolder(product.folder);
      setImage(product.url);
      setDescription(product.description)
    }
  }, [product]);

  const folderOptions = folders.map((f, index) => (
    <MenuItem key={index} value={f.id}>
      {f.id}
    </MenuItem>
  ));

  return (
    <Fade in>
      <div className={classes.root}>
        <div className={classes.header}>
          <Typography variant="h5" component="h5">
            {headerText}
          </Typography>
        </div>
        <div className={classes.form}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={10} className={classes.margin}>
              <FormControl fullWidth size="medium" variant="outlined" required>
                <InputLabel htmlFor="outlined-adornment-item">
                  Nombre del producto
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-item"
                  value={name}
                  onChange={(e) => setName(e.currentTarget.value)}
                  autoComplete="off"
                  startAdornment={
                    <InputAdornment position="start">Aa</InputAdornment>
                  }
                  labelWidth={170}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} md={3} className={classes.margin}>
              <FormControl size="medium" fullWidth variant="outlined" required>
                <InputLabel htmlFor="outlined-adornment-price">
                  Puntos
                </InputLabel>
                <OutlinedInput
                  onChange={(e) => setUnitPrice(e.currentTarget.value)}
                  value={unitPrice}
                  id="outlined-adornment-price"
                  type="number"
                  startAdornment={
                    <InputAdornment position="start">123</InputAdornment>
                  }
                  labelWidth={70}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={4} className={classes.margin}>
              <FormControl fullWidth variant="outlined" required>
                <InputLabel id="folder">Folder</InputLabel>
                <Select
                  labelId="folder"
                  id="select-helper"
                  labelWidth={60}
                  onChange={(e) => setFolder(e.target.value)}
                  value={folder}
                >
                  {folderOptions}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={9} className={classes.margin}>
              <FormControl fullWidth size="medium" variant="outlined" required>
                <InputLabel htmlFor="outlined-adornment-description">
                  Descripción
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-description"
                  multiline
                  maxRows={3}
                  onChange={(e) => setDescription(e.currentTarget.value)}
                  value={description}
                  autoComplete="off"
                  startAdornment={
                    <InputAdornment position="start">Aa</InputAdornment>
                  }
                  labelWidth={95}
                />
              </FormControl>
            </Grid>
            {typeof image !== "undefined" && (
              <Grid item xs={12}>
                <img alt="img-form" className={classes.img} src={image} />
              </Grid>
            )}
            <Grid item xs={12}>
              <label htmlFor="upload-photo">
                <input
                  style={{ display: "none" }}
                  id="upload-photo"
                  name="upload-photo"
                  type="file"
                  onChange={(e) =>
                    handleFileSelection(e.currentTarget.files[0])
                  }
                  accept="image/x-png,image/jpg,image/jpeg"
                />
                <Button
                  color="secondary"
                  variant="contained"
                  component="span"
                  startIcon={<ImageIcon />}
                >
                  Subir Imagen
                </Button>
              </label>
              <Button
                style={{
                  marginLeft: 15,
                  backgroundColor: "green",
                  color: "white",
                }}
                variant="contained"
                component="span"
                disabled={loading}
                startIcon={<AddBoxIcon />}
                onClick={() =>
                  onSubmit({
                    name,
                    unitPrice,
                    description,
                    folder,
                    file,
                    editedFile,
                  })
                }
              >
                {loading ? "Loading" : submitText}
              </Button>
            </Grid>
            <Grid item xs={12}>
              {errors}
            </Grid>
          </Grid>
        </div>
      </div>
    </Fade>
  );
};
export default ProductsForm;
